import React, {
  useState,
  useEffect,
} from "react";
import {
  X,
  Building2,
  MapPin,
  Star,
  Phone,
  Mail,
  Globe,
  Save,
  Loader2,
ImagePlus,
Trash2,
} from "lucide-react";

import hotelService from "../../services/hotelService";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";

const CreateHotelModal = ({
  isOpen,
  onClose,
  onSuccess,
  hotel,
}) => {

 const [loading, setLoading] = useState(false);
 const [errors, setErrors] = useState({});
const [selectedImages, setSelectedImages] = useState([]);

const [imagePreviews, setImagePreviews] = useState([]);
const isEditMode = !!hotel;
  const [formData, setFormData] = useState({
    name: "",

    location: {
      city: "",
      state: "",
      country: "India",
      address: "",
    },

    category: "mid-range",

    starRating: 3,

    contact: {
      phone: "",
      email: "",
      website: "",
      manager: "",
    },

    amenities: [],

    policies: {
      checkIn: "12:00 PM",
      checkOut: "11:00 AM",
      cancellation: "",
    },

    notes: "",
  });

  const [amenityInput, setAmenityInput] = useState("");

useEffect(() => {

  if (!hotel || !isOpen) return;

  setFormData({

    name: hotel.name || "",

    location: {
      city:
        hotel.location?.city || "",
      state:
        hotel.location?.state || "",
      country:
        hotel.location?.country ||
        "India",
      address:
        hotel.location?.address ||
        "",
    },

    category:
      hotel.category ||
      "mid-range",

    starRating:
      hotel.starRating || 3,

    contact: {
      phone:
        hotel.contact?.phone || "",
      email:
        hotel.contact?.email || "",
      website:
        hotel.contact?.website || "",
      manager:
        hotel.contact?.manager || "",
    },

    amenities:
      hotel.amenities || [],

    policies: {
      checkIn:
        hotel.policies?.checkIn ||
        "12:00 PM",

      checkOut:
        hotel.policies?.checkOut ||
        "11:00 AM",

      cancellation:
        hotel.policies
          ?.cancellation || "",
    },

    notes:
      hotel.notes || "",
  });

  const existingImages =
    (hotel.images || []).map(
      (img) => ({
        existing: true,
        _id: img._id,
        url: img.url,
      })
    );

  setImagePreviews(existingImages);

}, [hotel, isOpen]);

  const updateNested = (parent, field, value) => {
    setFormData((prev) => ({
      ...prev,
      [parent]: {
        ...prev[parent],
        [field]: value,
      },
    }));
  };

  const validate = () => {
    const e = {};

    if (!formData.name.trim()) e.name = "Hotel name required";

    if (!formData.location.city.trim())
      e.city = "City required";

    if (!formData.location.state.trim())
      e.state = "State required";

    if (!formData.location.country.trim())
      e.country = "Country required";

    setErrors(e);

    return Object.keys(e).length === 0;
  };

  const addAmenity = () => {
    if (!amenityInput.trim()) return;

    if (formData.amenities.includes(amenityInput.trim())) return;

    setFormData((prev) => ({
      ...prev,
      amenities: [...prev.amenities, amenityInput.trim()],
    }));

    setAmenityInput("");
  };

  const removeAmenity = (item) => {
    setFormData((prev) => ({
      ...prev,
      amenities: prev.amenities.filter((a) => a !== item),
    }));
  };

const handleImageSelect = (e) => {

  const files = Array.from(e.target.files || []);

  if (!files.length) return;

  const validFiles = files.filter((file) =>
    file.type.startsWith("image/")
  );

  setSelectedImages((prev) => [
    ...prev,
    ...validFiles,
  ]);

  const previews = validFiles.map((file) => ({
    file,
    url: URL.createObjectURL(file),
  }));

  setImagePreviews((prev) => [
    ...prev,
    ...previews,
  ]);
};

const removeImage = async (
  index
) => {

  const image =
    imagePreviews[index];

  try {

    /* ===============================
       EXISTING IMAGE DELETE
    =============================== */

    if (
      image?.existing &&
      hotel?._id
    ) {

      await hotelService.deleteImage(
        hotel._id,
        image._id
      );
    }

    setSelectedImages((prev) =>
      prev.filter(
        (_, i) => i !== index
      )
    );

    setImagePreviews((prev) =>
      prev.filter(
        (_, i) => i !== index
      )
    );

  } catch (err) {

    console.error(err);

    setErrors({
      submit:
        "Failed to delete image",
    });
  }
};

const handleSubmit = async (e) => {

  e.preventDefault();

  if (!validate()) return;

  try {

    setLoading(true);

    const payload = {
      ...formData,
      source: "Manual",
    };

    let savedHotel;

    /* =====================================
       CREATE MODE
    ===================================== */

    if (!isEditMode) {

      const response =
        await hotelService.create(
          payload
        );

      if (
        !response.data.success
      ) {

        throw new Error(
          "Hotel creation failed"
        );
      }

      savedHotel =
        response.data.data;

    } else {

      /* =====================================
         EDIT MODE
      ===================================== */

      const response =
        await hotelService.update(
          hotel._id,
          payload
        );

      if (
        !response.data.success
      ) {

        throw new Error(
          "Hotel update failed"
        );
      }

      savedHotel =
        response.data.data;
    }

    /* =====================================
       IMAGE UPLOAD
    ===================================== */

    if (
      selectedImages.length > 0
    ) {

      const formDataImages =
        new FormData();

      selectedImages.forEach(
        (image) => {

          formDataImages.append(
            "images",
            image
          );
        }
      );

      await hotelService.uploadImages(
        savedHotel._id,
        formDataImages
      );
    }

    onSuccess?.(savedHotel);

    handleClose();

  } catch (err) {

    console.error(err);

    setErrors({
      submit:
        err?.response?.data
          ?.message ||
        err?.message ||
        "Failed to save hotel",
    });

  } finally {

    setLoading(false);
  }
};

  const handleClose = () => {
    setErrors({});
    setAmenityInput("");

    setFormData({
      name: "",

      location: {
        city: "",
        state: "",
        country: "India",
        address: "",
      },

      category: "mid-range",

      starRating: 3,

      contact: {
        phone: "",
        email: "",
        website: "",
        manager: "",
      },

      amenities: [],

      policies: {
        checkIn: "12:00 PM",
        checkOut: "11:00 AM",
        cancellation: "",
      },

      notes: "",
    });
setSelectedImages([]);

setImagePreviews([]);

    onClose?.();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex justify-center items-center p-6">
      <Card className="w-full max-w-5xl max-h-[95vh] overflow-y-auto rounded-2xl border border-gray-200 shadow-2xl">

        <CardHeader className="border-b bg-white sticky top-0 z-10">
          <div className="flex items-center justify-between">
            <CardTitle className="flex items-center gap-3 text-xl font-semibold">
              <Building2 className="w-6 h-6 text-blue-600" />
              {isEditMode
  ? "Edit Hotel"
  : "Create Hotel"}
            </CardTitle>

            <Button
              variant="ghost"
              size="icon"
              onClick={handleClose}
            >
              <X className="w-5 h-5" />
            </Button>
          </div>
        </CardHeader>

        <CardContent className="p-8">

          <form onSubmit={handleSubmit} className="space-y-8">

            {/* BASIC INFO */}

            <div>
              <h2 className="text-lg font-semibold mb-4">
                Basic Information
              </h2>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-5">

                <div>
                  <label className="text-sm font-medium">
                    Hotel Name
                  </label>

                  <Input
                    value={formData.name}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        name: e.target.value,
                      })
                    }
                    placeholder="Taj Palace Delhi"
                  />

                  {errors.name && (
                    <p className="text-red-500 text-xs mt-1">
                      {errors.name}
                    </p>
                  )}
                </div>

                <div>
                  <label className="text-sm font-medium">
                    Star Rating
                  </label>

                  <Input
                    type="number"
                    min="1"
                    max="5"
                    step="1"
                    value={formData.starRating}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        starRating: Number(e.target.value),
                      })
                    }
                  />
                </div>

              </div>
            </div>

            {/* LOCATION */}

            <div>
              <h2 className="text-lg font-semibold mb-4">
                Location
              </h2>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-5">

                <div>
                  <label className="text-sm font-medium">
                    City
                  </label>

                  <Input
                    value={formData.location.city}
                    onChange={(e) =>
                      updateNested(
                        "location",
                        "city",
                        e.target.value
                      )
                    }
                  />
                </div>

                <div>
                  <label className="text-sm font-medium">
                    State
                  </label>

                  <Input
                    value={formData.location.state}
                    onChange={(e) =>
                      updateNested(
                        "location",
                        "state",
                        e.target.value
                      )
                    }
                  />
                </div>

                <div>
                  <label className="text-sm font-medium">
                    Country
                  </label>

                  <Input
                    value={formData.location.country}
                    onChange={(e) =>
                      updateNested(
                        "location",
                        "country",
                        e.target.value
                      )
                    }
                  />
                </div>

                <div>
                  <label className="text-sm font-medium">
                    Address
                  </label>

                  <Input
                    value={formData.location.address}
                    onChange={(e) =>
                      updateNested(
                        "location",
                        "address",
                        e.target.value
                      )
                    }
                  />
                </div>

              </div>
            </div>

            {/* CONTACT */}

            <div>
              <h2 className="text-lg font-semibold mb-4">
                Contact
              </h2>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-5">

                <Input
                  placeholder="Phone"
                  value={formData.contact.phone}
                  onChange={(e) =>
                    updateNested(
                      "contact",
                      "phone",
                      e.target.value
                    )
                  }
                />

                <Input
                  placeholder="Email"
                  value={formData.contact.email}
                  onChange={(e) =>
                    updateNested(
                      "contact",
                      "email",
                      e.target.value
                    )
                  }
                />

                <Input
                  placeholder="Website"
                  value={formData.contact.website}
                  onChange={(e) =>
                    updateNested(
                      "contact",
                      "website",
                      e.target.value
                    )
                  }
                />

                <Input
                  placeholder="Manager"
                  value={formData.contact.manager}
                  onChange={(e) =>
                    updateNested(
                      "contact",
                      "manager",
                      e.target.value
                    )
                  }
                />

              </div>
            </div>

            {/* AMENITIES */}

            <div>
              <h2 className="text-lg font-semibold mb-4">
                Amenities
              </h2>

              <div className="flex gap-2">

                <Input
                  value={amenityInput}
                  onChange={(e) =>
                    setAmenityInput(e.target.value)
                  }
                  placeholder="Pool, Spa, WiFi..."
                />

                <Button
                  type="button"
                  onClick={addAmenity}
                >
                  Add
                </Button>
              </div>

              <div className="flex flex-wrap gap-2 mt-4">

                {formData.amenities.map((item) => (
                  <div
                    key={item}
                    className="px-3 py-1 rounded-full bg-blue-100 text-blue-700 text-sm flex items-center gap-2"
                  >
                    {item}

                    <button
                      type="button"
                      onClick={() => removeAmenity(item)}
                    >
                      ×
                    </button>
                  </div>
                ))}

              </div>
            </div>

{/* HOTEL IMAGES */}

<div>

  <h2 className="text-lg font-semibold mb-4">
    Hotel Images
  </h2>

  <div className="space-y-4">

    <label className="border-2 border-dashed border-gray-300 rounded-xl p-8 flex flex-col items-center justify-center cursor-pointer hover:border-blue-500 transition">

      <ImagePlus className="w-10 h-10 text-gray-400 mb-3" />

      <span className="text-sm text-gray-600">
        Click to upload hotel images
      </span>

      <input
        type="file"
        multiple
        accept="image/*"
        className="hidden"
        onChange={handleImageSelect}
      />

    </label>

    {imagePreviews.length > 0 && (

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">

        {imagePreviews.map((image, index) => (

          <div
            key={index}
            className="relative rounded-xl overflow-hidden border bg-white"
          >

            <img
              src={
    image.existing
      ? `${window.location.origin}${image.url}`
      : image.url
  }
              alt="preview"
              className="w-full h-32 object-cover"
            />

            <button
              type="button"
              onClick={() => removeImage(index)}
              className="absolute top-2 right-2 bg-black/70 text-white rounded-full p-1"
            >
              <Trash2 className="w-4 h-4" />
            </button>

            {index === 0 && (
              <div className="absolute bottom-2 left-2 bg-blue-600 text-white text-xs px-2 py-1 rounded">
                Primary
              </div>
            )}

          </div>
        ))}

      </div>
    )}

  </div>

</div>

            {/* NOTES */}

            <div>
              <label className="text-sm font-medium">
                Internal Notes
              </label>

              <textarea
                rows={4}
                value={formData.notes}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    notes: e.target.value,
                  })
                }
                className="w-full border rounded-lg p-3 mt-1"
              />
            </div>

            {/* ERRORS */}

            {errors.submit && (
              <div className="bg-red-50 border border-red-200 p-4 rounded-lg text-red-600 text-sm">
                {errors.submit}
              </div>
            )}

            {/* FOOTER */}

            <div className="flex justify-end gap-3 border-t pt-6">

              <Button
                type="button"
                variant="outline"
                onClick={handleClose}
                disabled={loading}
              >
                Cancel
              </Button>

              <Button
                type="submit"
                disabled={loading}
                className="min-w-[140px]"
              >
                {loading ? (
                  <div className="flex items-center gap-2">
                    <Loader2 className="w-4 h-4 animate-spin" />
                    {isEditMode
  ? "Updating..."
  : "Creating..."}
                  </div>
                ) : (
                  <div className="flex items-center gap-2">
                    <Save className="w-4 h-4" />
                    {isEditMode
  ? "Update Hotel"
  : "Create Hotel"}
                  </div>
                )}
              </Button>

            </div>

          </form>

        </CardContent>
      </Card>
    </div>
  );
};

export default CreateHotelModal;
